<template>
  <div class="sheriff-card">
    <div class="sheriff-header">
      <div class="sheriff-logo">
        SHERIFF <span class="sheriff-divider">|</span>
        <span class="sheriff-logo-sub">ПУЛЬТОВА ОХОРОНА</span>
      </div>
      <button class="sheriff-badge-btn">Запрошення від друга</button>
      <div class="sheriff-phone">
        <span class="sheriff-phone-label">Виникли питання?</span>
        <span class="sheriff-phone-number">0 800 309 114</span>
        <span class="sheriff-phone-free">безкоштовно</span>
      </div>
    </div>

    <div class="sheriff-divider-line"></div>

    <div class="sheriff-steps">
      <div class="sheriff-step">
        <div class="sheriff-step-label">КРОК 1</div>
        <div class="sheriff-step-title">Залишаєте заявку</div>
        <div class="sheriff-step-text">Ім'я і номер телефону — 20 секунд.</div>
      </div>
      <div class="sheriff-step">
        <div class="sheriff-step-label">КРОК 2</div>
        <div class="sheriff-step-title">Ми підключаємо пультову охорону</div>
        <div class="sheriff-step-text">
          Виїзд майстра і пультове підключення.
        </div>
      </div>
      <div class="sheriff-bonus">
        <div class="sheriff-bonus-label">ВАШ БОНУС</div>
        <div class="sheriff-bonus-amount">
          750 <span class="sheriff-bonus-currency">₴</span>
        </div>
        <div class="sheriff-bonus-text">
          Нараховуємо після підключення охорони.
        </div>
      </div>
    </div>

    <div class="sheriff-form-block">
      <div class="sheriff-tag">Запрошення від друга</div>
      <h2 class="sheriff-title">Підключіть пультову охорону</h2>
      <p class="sheriff-subtitle">
        Два поля. Передзвонимо протягом робочого дня.
      </p>

      <div class="sheriff-inputs">
        <div class="sheriff-input-wrap">
          <svg
            class="sheriff-input-icon"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"
              fill="currentColor"
            />
          </svg>
          <input
            type="text"
            v-model="referralInfo.name"
            class="sheriff-input"
            :class="{ 'sheriff-input--error': error.name }"
            placeholder="Ваше ім'я"
          />
        </div>
        <div class="sheriff-input-wrap">
          <svg
            class="sheriff-input-icon"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.2.4 2.4.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.9 21 3 13.1 3 3c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.2 1L6.6 10.8z"
              fill="currentColor"
            />
          </svg>
          <input
            type="tel"
            v-model="referralInfo.phone"
            class="sheriff-input"
            :class="{ 'sheriff-input--error': error.phone }"
            placeholder="+38 (0__) ___ __ __"
            v-mask="'380#########'"
          />
        </div>
      </div>

      <div class="sheriff-submit-row">
        <button
          class="sheriff-submit-btn"
          :disabled="referralAdded"
          @click="addReferral"
        >
          {{
            referralAdded ? "Заявку прийнято" : "Підключити і отримати 750 ₴"
          }}
        </button>
        <p class="sheriff-consent">
          Натискаючи кнопку, ви даєте згоду на обробку персональних даних. Бонус
          750 ₴ нараховуємо після підключення охорони.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      referralInfo: {
        name: "",
        phone: "",
      },
      error: {
        name: false,
        phone: false,
      },
      referralAdded: false,
    };
  },
  methods: {
    addReferral() {
      if (
        this.referralInfo.name.length >= 2 &&
        this.referralInfo.phone.length >= 12
      ) {
        this.axios
          .post(`${this.$domain}/referral`, {
            referrer_id: this.$route.params.id,
            name: this.referralInfo.name,
            phone: this.referralInfo.phone,
          })
          .then((response) => {
            if (response.data.result === "success") {
              this.referralAdded = true;

              this.$swal.fire({
                icon: "success",
                html: `<span style="color: #fff;">Заявка прийнята! <br/> З Вами зв'яжеться наш менеджер</span>`,
              });
            } else if (response.data.result === "failed") {
              this.$swal.fire({
                icon: "error",
                html: `<span style="color: #fff;">На жаль, користувач <br/> з таким номером телефону вже існує</span>`,
              });
            }
          });
      } else {
        if (!this.referralInfo.name.length) {
          this.error.name = true;
        }
        if (this.referralInfo.phone.length < 12) {
          this.error.phone = true;
        }
      }
    },
  },
  watch: {
    "referralInfo.name"() {
      this.error.name = !this.referralInfo.name.length;
    },
    "referralInfo.phone"() {
      this.error.phone = this.referralInfo.phone.length < 12;
    },
  },
};
</script>

<style scoped>
.sheriff-card {
  background: #ffffff;
  border-radius: 32px;
  padding: 40px 48px 48px;
  max-width: 1120px;
  margin: 0 auto;
  font-family: "Gotham Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Arial, sans-serif;
  box-sizing: border-box;
}

.sheriff-header {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}

.sheriff-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 900;
  font-size: 20px;
  letter-spacing: 0.5px;
  color: #111111;
}

.sheriff-divider {
  color: #d0d0d0;
  font-weight: 300;
}

.sheriff-logo-sub {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #6b6b6b;
}

.sheriff-badge-btn {
  background: #fff9d6;
  color: #8a7b00;
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.sheriff-phone {
  margin-left: auto;
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.sheriff-phone-label {
  font-size: 13px;
  color: #8a8a8a;
}

.sheriff-phone-number {
  font-size: 20px;
  font-weight: 800;
  color: #111111;
}

.sheriff-phone-free {
  font-size: 13px;
  color: #8a8a8a;
}

.sheriff-divider-line {
  height: 1px;
  background: #eeeeee;
  margin-bottom: 24px;
}

.sheriff-steps {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 32px;
}

.sheriff-step {
  background: #f6f6f6;
  border-radius: 20px;
  padding: 24px;
}

.sheriff-step-label {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #a3a3a3;
  margin-bottom: 12px;
}

.sheriff-step-title {
  font-size: 19px;
  font-weight: 800;
  color: #111111;
  margin-bottom: 8px;
  line-height: 1.25;
}

.sheriff-step-text {
  font-size: 14px;
  color: #8a8a8a;
  line-height: 1.4;
}

.sheriff-bonus {
  background: #ffd400;
  border-radius: 20px;
  padding: 24px;
}

.sheriff-bonus-label {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #7a6b00;
  margin-bottom: 12px;
}

.sheriff-bonus-amount {
  font-size: 44px;
  font-weight: 900;
  color: #111111;
  line-height: 1;
  margin-bottom: 12px;
}

.sheriff-bonus-currency {
  font-size: 24px;
  font-weight: 800;
}

.sheriff-bonus-text {
  font-size: 14px;
  font-weight: 600;
  color: #55482a;
  line-height: 1.4;
}

.sheriff-form-block {
  padding-top: 8px;
}

.sheriff-tag {
  display: inline-block;
  background: #fff3b0;
  color: #8a7b00;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 20px;
}

.sheriff-title {
  font-size: 36px;
  font-weight: 900;
  color: #111111;
  margin: 0 0 12px;
  line-height: 1.15;
}

.sheriff-subtitle {
  font-size: 16px;
  color: #6b6b6b;
  margin: 0 0 24px;
}

.sheriff-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
}

.sheriff-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.sheriff-input-icon {
  position: absolute;
  left: 18px;
  color: #b0b0b0;
  pointer-events: none;
}

.sheriff-input {
  width: 100%;
  background: #f6f6f6;
  border: 2px solid transparent;
  border-radius: 16px;
  padding: 18px 18px 18px 48px;
  font-size: 16px;
  color: #111111;
  box-sizing: border-box;
  outline: none;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.sheriff-input::placeholder {
  color: #a3a3a3;
}

.sheriff-input:focus {
  box-shadow: 0 0 0 2px #ffd400;
}

.sheriff-input--error {
  border-color: #ff5252;
}

.sheriff-submit-row {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.sheriff-submit-btn {
  background: #ffd400;
  border: none;
  border-radius: 16px;
  padding: 20px 32px;
  font-size: 17px;
  font-weight: 800;
  color: #111111;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;
}

.sheriff-submit-btn:hover {
  background: #f0c800;
}

.sheriff-submit-btn:disabled {
  background: #eeeeee;
  color: #a3a3a3;
  cursor: not-allowed;
}

.sheriff-consent {
  flex: 1;
  min-width: 220px;
  font-size: 13px;
  color: #8a8a8a;
  line-height: 1.5;
  margin: 0;
}

@media (max-width: 768px) {
  .sheriff-header {
    margin-bottom: 12px;
  }

  .sheriff-divider-line {
    display: none;
  }

  .sheriff-card {
    padding: 28px 20px 32px;
    border-radius: 24px;
  }

  .sheriff-steps {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }

  .sheriff-step {
    display: none;
  }

  .sheriff-bonus {
    order: -1;
  }

  .sheriff-inputs {
    grid-template-columns: 1fr;
  }

  .sheriff-title {
    font-size: 28px;
  }

  .sheriff-phone {
    margin-left: 0;
    display: none;
  }

  .sheriff-submit-btn {
    width: 100%;
  }

  .sheriff-badge-btn {
    display: none;
  }
}
</style>
